export default __webpack_public_path__ + "da35bf1dfc19c46cb25bebd01b7304e7.png";